var map = {
	"./0/atlas-m.png": 1614,
	"./0/atlas.png": 624,
	"./0/first-m.png": 4214,
	"./0/first.png": 9497,
	"./0/next-m.png": 7940,
	"./0/next.png": 7802,
	"./0/slider/01.png": 5257,
	"./0/slider/02.png": 2725,
	"./0/slider/03.png": 439,
	"./0/slider/04.png": 7292,
	"./1/first-m.png": 2440,
	"./1/first.png": 7834,
	"./1/next.png": 9423,
	"./1/playboy-m.png": 8161,
	"./1/playboy.png": 8677,
	"./1/slider/01.png": 8602,
	"./1/slider/02.png": 4820,
	"./1/slider/03.png": 5865,
	"./1/slider/04.png": 2160,
	"./2/first-m.png": 8064,
	"./2/first.png": 2409,
	"./2/next.png": 5589,
	"./2/slider/01.png": 1699,
	"./2/slider/02.png": 2537,
	"./2/slider/03.png": 3959,
	"./2/slider/04.png": 2222,
	"./2/the_world_news-m.png": 8846,
	"./2/the_world_news.png": 8083,
	"./3/first-m.png": 5529,
	"./3/first.png": 7910,
	"./3/music_awards-m.png": 463,
	"./3/music_awards.png": 2818,
	"./3/next.png": 8306,
	"./3/slider/01.png": 1267,
	"./3/slider/02.png": 2610,
	"./3/slider/03.png": 7237,
	"./3/slider/04.png": 3174,
	"./4/first-m.png": 5069,
	"./4/first.png": 2471,
	"./4/next.png": 6130,
	"./4/slider/01.png": 1152,
	"./4/slider/02.png": 9500,
	"./4/slider/03.png": 9264,
	"./4/slider/04.png": 1257,
	"./4/unn-m.png": 1307,
	"./4/unn.png": 789,
	"./5/first-m.png": 4415,
	"./5/first.png": 4848,
	"./5/next.png": 7298,
	"./5/slider/01.png": 2479,
	"./5/slider/02.png": 8327,
	"./5/slider/03.png": 6216,
	"./5/slider/04.png": 6168,
	"./5/sluhay-m.png": 7774,
	"./5/sluhay.png": 2201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2800;